import { useEffect, useState } from "react";
import "./InativarModal.css";

export default function InativarModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function handleOk() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.message || "Falha ao inativar");
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    if (!open) return;

    setBusy(false);
    setErr("");

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose?.();
      }
      if (e.key === "Enter") {
        e.preventDefault();
        handleOk();
      }
    };

    document.addEventListener("keydown", onKey, true);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey, true);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="invmd-bg">
      <div className="invmd-box" role="dialog" aria-modal="true" aria-label="Inativar ativo">
        <header className="invmd-head">
          <h3 className="invmd-title">Inativar</h3>
          <button className="invmd-x" onClick={onClose} type="button" aria-label="Fechar" title="Fechar" disabled={busy}>
            x
          </button>
        </header>

        <div className="invmd-body">
          Deseja <strong>inativar</strong> "{titulo || "este item"}"?
          {err ? <div className="invmd-err">{err}</div> : null}
        </div>

        <footer className="invmd-foot">
          <button className="invmd-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="invmd-btn invmd-btn-warn" type="button" onClick={handleOk} disabled={busy}>
            {busy ? "Inativando..." : "Inativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}
